<template>
    <InstructionSheet></InstructionSheet>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const InstructionSheet = defineAsyncComponent(() =>
    import("../../components/Design/InstructionSheet/InstructionSheet.vue")
);

export default {
    name: "InstructionSheetPage", //The name you are in should not equal the name of the component you are importing.
    components: { InstructionSheet, AuthLayout },
};
</script>
